/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/58249699
 */

import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import filter from 'ramda/src/filter';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { ManageAssignments, LibraryTypes, ProgramTypes } from '~/services/config';

const List = (props) => {
    const { userRole, current, perPage, onChange, onSelect } = props;
    const data = filter((program) => program.status !== 3, props.data);
    const totalPage = data.length < perPage ? current : data.length;

    return (
        <div className="assignments-program-card px-4">
            <div className="dsl-b16 bold mb-2">Programs</div>
            <div className="card-item pb-4 desktop-screen">
                <div className="d-flex-5 d-flex-ssm-1">
                    <p className="dsl-m12 text-400 m-0">Programs</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-center text-400 ms-3 mb-0">Courses</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-end text-400 m-0">Habits</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-end text-400 m-0 ">Goals</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-end text-400 m-0">Docs</p>
                </div>
                <div className="d-flex-2">
                    <p className="dsl-m12 text-center text-400 m-0">Assigned</p>
                </div>
                <div className="d-flex-2">
                    <p className="dsl-m12 text-400 m-0">Est Completion</p>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 text-end text-400 m-0">Completed</p>
                </div>
                <div className="edit desktop-screen" />
            </div>
            {isNil(data) || isEmpty(data) ? (
                <div className="d-h-center pt-4">
                    <span className="dsl-m16">No active programs.</span>
                </div>
            ) : (
                <>
                    {data.map((program) => {
                        const type = ProgramTypes[program.type - 1];
                        const { courses, habits, quotas } = program.data.stats;
                        const habitsComplete = isNil(habits) ? 0 : habits.day.complete + habits.week.complete + habits.month.complete;
                        const habitsTotal = isNil(habits) ? 0 : habits.day.total + habits.week.total + habits.month.total;
                        const habitsCompletion = habitsTotal === 0 ? 0 : Math.ceil((habitsComplete * 100) / habitsTotal);
                        const totalsCompletion = Math.ceil(((habitsComplete + quotas.complete + courses.complete) * 100) / (habitsTotal + courses.total + quotas.total));
                        const programCount = data?.length;
                        return (
                            <div className={cx('card-item', programCount > 3 && 'cardCount')} key={program.id}>
                                <div className="d-flex ai-center d-flex-5 mb-0 ssm-b-2 w-100">
                                    <div className="d-h-between w-100">
                                        <div className="d-flex ai-center">
                                            <Thumbnail source={LibraryTypes[type].icon} label={LibraryTypes[type].label} />
                                            <p className="dsl-b14 my-0 mx-md-3 mx-2 text-400">{program.title}</p>
                                        </div>
                                        <div className="tablet-block edit-programs">
                                            <EditDropdown options={ManageAssignments[userRole]} onChange={(e) => onSelect(e, program)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex-1 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Courses</label>
                                    <div className="d-flex flex-md-column">
                                        <p className="dsl-b14 text-end mb-1 text-400">
                                            {courses.complete}/{courses.total}
                                        </p>
                                        <p className="dsl-b12 text-end mb-0 ms-1">{courses.completion}%</p>
                                    </div>
                                </div>
                                <div className="d-flex-1 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Habits</label>
                                    <p className="dsl-b14 text-end mb-1 text-400">
                                        {habitsComplete}/{habitsTotal}
                                    </p>
                                    <p className="dsl-b12 text-end mb-0 ms-1">{habitsCompletion}%</p>
                                </div>
                                <div className="d-flex-1 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Goals</label>
                                    <p className="dsl-b14 text-end mb-1 text-400">
                                        {quotas.complete}/{quotas.total}
                                    </p>
                                    <p className="dsl-b12 text-end mb-0">{quotas.completion}%</p>
                                </div>
                                <div className="d-flex-1 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Docs</label>
                                    <p className="dsl-b14 text-end mb-1 text-400">N/A</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Assigned</label>
                                    <p className="dsl-b14 text-center mb-1 text-400">{moment.utc(program.created_at).local().format('MMM DD, YY')}</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Est Completion</label>
                                    <p className="dsl-b14 mb-1 text-400">{moment.utc(program.estimated_completion).local().format('MMM DD, YY')}</p>
                                </div>
                                <div className="d-flex-1 d-flex flex-md-column mb-0 ssm-b-2 w-100">
                                    <label className="w-40 tablet-block mb-0 dsl-m12 text-400">Completed</label>
                                    <p className="dsl-b14 text-end mb-1 text-400">{isNaN(totalsCompletion) ? 0 : totalsCompletion}%</p>
                                </div>
                                <div className="edit desktop-only">
                                    <EditDropdown options={ManageAssignments[userRole]} onChange={(e) => onSelect(e, program)} />
                                </div>
                            </div>
                        );
                    })}
                    <Pagination perPage={perPage} current={current} total={totalPage} onChange={onChange} />
                </>
            )}
        </div>
    );
};

export { List };
